(function($) {
	$(document).ready(function() {
		var $body = $('body');

		// Remove empty P tags created by WP inside of Accordion and Orbit
		$('.accordion p:empty, .orbit p:empty').remove();

		// Adds Flex Video to YouTube and Vimeo Embeds
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
			if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
			} else {
			$(this).wrap("<div class='responsive-embed'/>");
			}
		});

		if( $body.hasClass('home') ) {
			$('.js-subscribe a').on('click', function(e) {
				e.preventDefault();

				var $target = $(this).attr('href');

				$('html, body').animate({
					scrollTop: $($target).offset().top
				}, 800);

				if ( $(this).parents('.off-canvas') ) {
					$('.js-off-canvas-overlay').trigger('click');
				}
			});

			$('.block-banner .banners').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				appendArrows: $('.block-banner .arrows')
			});

			$('.block-news .articles').slick({
				slidesToShow: 3,
				slidesToScroll: 3,
				dots: false,
				appendArrows: $('.block-news .arrows'),
				responsive: [
					{
					breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});
			$('.block-artists .articles').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				appendArrows: $('.block-artists .arrows')
			});
			$('.block-store .articles').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				appendArrows: $('.block-store .arrows')
			});

		} else { // home
			$('.js-subscribe a').on('click', function(e) {
				e.preventDefault();
				$('#ae-cform-modal-display-cta-1').trigger('click');
			});
		}
			
		$('.block-videos .articles').slick({
			slidesToShow: 3,
			dots: false,
			centerMode: true,
			centerPadding: '50px',
			  cssEase: 'linear',
			responsive: [
				{
				breakpoint: 480,
					settings: {
						centerMode: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						appendArrows: $('.block-videos .arrows')
					}
				}
			]
		});

		$('#ae-cform-input-reg-email-1').attr('placeholder', 'Email Address');

		$('.js-filter-all').on('click', function(e){
			e.preventDefault();
			$(this).addClass('active');
			$('.js-filter-cat').removeClass('active');
			
			$.ajax({
				type: 'POST',
				url: ajax_url,
				dataType: 'html',
				data: { action: 'data_all' },
				success: function(data) {
					$('#datafetch').html( data );
				}
			});
		});

		$('.js-filter-cat').on('click', function(e) {
			e.preventDefault();
			$('.js-filter-all, .js-filter-cat').removeClass('active');
			$(this).addClass('active');

			$.ajax({
				type: 'POST',
				url: ajax_url,
				dataType: 'html',
				data: {
					action: 'filter_playlist',
					category: $(this).data('cat'),
				},
				success: function(res) {
					$('#datafetch').html(res);
				}
			})
		});

		$('#keyword').keyup(function() {
			fetch();
			$('#datafetch').addClass('loading');
		});

		function fetch(){
			$.ajax({
				url: ajax_url,
				type: 'post',
				data: { action: 'data_fetch', keyword: $('#keyword').val() },
				success: function(data) {
					$('#datafetch').removeClass('loading').html( data );
				}
			});
		}

		$('.block-albums .articles').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			appendArrows: $('.block-albums .arrows')
		});
	});
})(jQuery);